import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Product, RootObject} from '../models/product';
import {BaseService} from '../../../services/base.service';
import {Categories} from '../models/categories';
import {map} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {Customer} from '../models/CustomerInfo/Customer';
import {Attribute} from '../models/attribute';
import {Role} from '../../admin/models/role';
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class ProductService extends BaseService {

    private ProductFilterChangedEventEmitter = new Subject<any>();
    private ProductCategoryFilterChangedEventEmitter = new Subject<any>();
    public filterData = [];

    public ProductFilterChangedEvent$ = this.ProductFilterChangedEventEmitter.asObservable();
    public ProductCategoryFilterChangedEvent$ = this.ProductCategoryFilterChangedEventEmitter.asObservable();

    constructor(private httpClient: HttpClient) {
        super();
    }

    getProductData(): Observable<RootObject> {
        // tslint:disable-next-line:max-line-length

        return this.httpClient.get<RootObject>(this.baseAPI + `products?searchCriteria%5BfilterGroups%5D%5B0%5D%5Bfilters%5D%5B0%5D%5Bfield%5D=category_id&searchCriteria%5BfilterGroups%5D%5B0%5D%5Bfilters%5D%5B0%5D%5Bvalue%5D=1040&searchCriteria[currentPage]=0&searchCriteria[pageSize]=12`);
    }


    ProductSearchAdv(field, value, op, visibility = 4, website_id = 1) {

        const params = new HttpParams()
            .set('searchCriteria[filter_groups][0][filters][0][field]', 'website_id')
            .set('searchCriteria[filter_groups][0][filters][0][value]', website_id)
            .set('searchCriteria[filter_groups][0][filters][0][condition_type]', 'eq')
            .set('searchCriteria[filter_groups][1][filters][0][field]', field)
            .set('searchCriteria[filter_groups][1][filters][0][value]', value)
            .set('searchCriteria[filter_groups][1][filters][0][condition_type]', op)
            .set('searchCriteria[filter_groups][2][filters][0][field]', 'visibility')
            .set('searchCriteria[filter_groups][2][filters][0][value]', visibility)
            .set('searchCriteria[filter_groups][2][filters][0][condition_type]', 'eq')
            .set('searchCriteria[pageSize]', '50')
            .set('searchCriteria[currentPage]', '1');

        const serviceURL = this.baseAPI + 'products';

        return this.httpClient.get<any>(serviceURL, {params: params});

    }


    getProductDataBasedId(id): Observable<RootObject> {
        // tslint:disable-next-line:max-line-length
        return this.httpClient.get<RootObject>(this.baseAPI + `products?searchCriteria%5BfilterGroups%5D%5B0%5D%5Bfilters%5D%5B0%5D%5Bfield%5D=category_id&searchCriteria%5BfilterGroups%5D%5B0%5D%5Bfilters%5D%5B0%5D%5Bvalue%5D=${id}&searchCriteria[currentPage]=0&searchCriteria[pageSize]=12`);
    }

    getCategoryProducts(category_id, pageSize = 80, currentPage = 1, website_id) {

        const params = new HttpParams()
            .set('searchCriteria[filter_groups][0][filters][0][field]', 'category_id')
            .set('searchCriteria[filter_groups][0][filters][0][value]', category_id)
            .set('searchCriteria[filter_groups][0][filters][0][condition_type]', 'eq')
            .set('searchCriteria[filter_groups][1][filters][0][field]', 'visibility')
            .set('searchCriteria[filter_groups][1][filters][0][value]', 4)
            .set('searchCriteria[filter_groups][1][filters][0][condition_type]', 'eq')
            .set('searchCriteria[filter_groups][2][filters][0][field]', 'website_id')
            .set('searchCriteria[filter_groups][2][filters][0][value]', website_id)
            .set('searchCriteria[filter_groups][2][filters][0][condition_type]', 'eq')
            .set('searchCriteria[sortOrders][0][field]', 'created_at')
            .set('searchCriteria[sortOrders][0][direction]', 'DESC')
            .set('searchCriteria[pageSize]', pageSize)
            .set('searchCriteria[currentPage]', currentPage);

        const serviceURL = 'V1/products?';
        return this.httpClient.get<Categories>(this.baseAPI + serviceURL, {params: params});
    }

    getProductDataSet(params, isSearchGrid = false): Observable<any> {
        let serviceURL = "";
        if (isSearchGrid) {
            serviceURL = this.baseAPI + 'products?';
        } else {
            serviceURL = this.baseAPI + 'products?';
        }


        // tslint:disable-next-line:max-line-length
        return this.httpClient.get<any>(serviceURL, {params: params});
        // .pipe(
        //     map(data => Object.assign(new Product(), data))
        //
        // );
    }

    getProductDetails(sku: string): Observable<any> {
        // tslint:disable-next-line:max-line-length
        return this.httpClient.get<any>(this.baseAPI + `products?searchCriteria[filterGroups][0][filters][0][field]=sku&searchCriteria[filterGroups][0][filters][0][value]=` + sku)
            .pipe(
                map(data => Object.assign(new Product(), data.items[0]))
            );

    }

    getCategoryFilters(category_id, store_id): Observable<any> {

        const obj = {
            'category_id': category_id,
            'store_id': this.storeId,
        };

        // tslint:disable-next-line:max-line-length
        return this.httpClient.post(this.baseAPI2 + '/mage/category/filters', obj)
            .pipe(
                map(data => data)
            );

    }

    getProductFiltered(obj): Observable<any> {


        // tslint:disable-next-line:max-line-length
        return this.httpClient.post(this.baseAPI2 + '/mage/filter/products', obj)
            .pipe(
                map(data => data)
            );

    }

    getProductsInStock(obj): Observable<any> {


        return this.httpClient.post(this.baseAPI2 + '/mage/products/stock', obj)
            .pipe(
                map(data => data)
            );

    }

    getProductDetailsFull(sku: string): Observable<any> {
        // tslint:disable-next-line:max-line-length
        return this.httpClient.get<any>(this.baseAPI + 'products/' + sku)
            .pipe(
                map(data => Object.assign(new Product(), data))
            );

    }


    // getChunckProducts(page) {
    // tslint:disable-next-line:max-line-length
    //     return this.httpClient.get<RootObject>(this.baseAPI + `products?searchCriteria%5BfilterGroups%5D%5B0%5D%5Bfilters%5D%5B0%5D%5Bfield%5D=category_id&searchCriteria%5BfilterGroups%5D%5B0%5D%5Bfilters%5D%5B0%5D%5Bvalue%5D=1040&searchCriteria[currentPage]=${page}&searchCriteria[pageSize]=8`);
    // }

    getProductDetailsFullByURLKey(url_key): Observable<any> {
        return this.httpClient.get<any>(this.baseAPI + `products?searchCriteria%5BfilterGroups%5D%5B0%5D%5Bfilters%5D%5B0%5D%5Bfield%5D=url_key&searchCriteria%5BfilterGroups%5D%5B0%5D%5Bfilters%5D%5B0%5D%5Bvalue%5D=${url_key}`)
            .pipe(
                map(data => Object.assign(new Product(), data.items[0]))
            );
    }


    getChunckProductsId(page, id) {
        return this.httpClient.get<RootObject>(this.baseAPI + `products?searchCriteria%5BfilterGroups%5D%5B0%5D%5Bfilters%5D%5B0%5D%5Bfield%5D=category_id&searchCriteria%5BfilterGroups%5D%5B0%5D%5Bfilters%5D%5B0%5D%5Bvalue%5D=${id}&searchCriteria[currentPage]=${page}&searchCriteria[pageSize]=20`);
    }


    /****** Categories *****/

    getCatrgoriesDet(id) {
        return this.httpClient.get<Categories>(this.baseAPI + `adham/categories?rootCategoryId=` + id);
    }

    getCatrgories() {
        return this.httpClient.get<Categories>(this.baseAPI + `adham/categories?rootCategoryId=2`);
    }

    getFullCatrgories() {
        return this.httpClient.get<Categories>(this.baseAPI + `adham/categories/flat`);
    }

    getFullCatrgoriesFlat() {
        return this.httpClient.get<Categories>(this.baseAPI2 + `mage/category`);
    }

    getProductsAttributes(sku, store_id) {

        let obj = {
            'sku': sku,
            'store_id': store_id
        }
        return this.httpClient.post<[]>(this.baseAPI2 + `/mage/product/attrs`, obj);
    }

    /*****/
    ResetProductFilter() {
        this.filterData = [];
        this.ProductFilterChangedEventEmitter.next([]);
    }


    /***** events **/
    EmitproductFilterChanged(data: any) {
        // this.filterData.push(data);
        this.ProductFilterChangedEventEmitter.next(data);
    }


    EmitproductCategoryFilterChanged(data: any) {
        // this.filterData.push(data);
        this.ProductCategoryFilterChangedEventEmitter.next(data);
    }


}
